import { store, getContext, getElement, useState, useEffect } from "@wordpress/interactivity";

const { state, actions, callbacks } = store('frs-blocks/content-switcher', {
  state: {},

  actions: {},

  callbacks: {}
});
